import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/App';
import { surfaceFor } from '@/lib/hosts';
import { sentrySetup, startSentry } from '@/lib/observability';
import { registerServiceWorker } from '@/lib/register-sw';
import '@/index.css';

const container = document.getElementById('root');
if (!container) throw new Error('index.html is missing #root');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

const surface = surfaceFor(window.location.hostname, window.location.pathname);
void startSentry(sentrySetup(import.meta.env, surface));
void registerServiceWorker(navigator.serviceWorker, import.meta.env.PROD);
